import { SessionErrorTitle, SessionDuplicateMsg, SessionTimeoutMsg, SystemErrorTitle, SystemErrorMsg, SessionDisconnected, SessionTimeOut, SystemError } from "../constants";
import { useNavigate } from "react-router-dom";
import sessionCheck from "./sessionCheck";

export const sessionDisconnectedCheck = async (
    screenId: string,
    action: string,
    yearEdition: string,
    navigate: ReturnType<typeof useNavigate>
) => {
    const res = await sessionCheck(screenId, action, yearEdition)
    if (res == SessionDisconnected) {
        navigate("/Error", { state: { title: SessionErrorTitle, message: SessionDuplicateMsg } });
        return true
    } else if (res == SessionTimeOut) {
        navigate("/Error", { state: { title: SessionErrorTitle, message: SessionTimeoutMsg } });
        return true
    } else if (res == SystemError) {
        navigate("/Error", { state: { title: SystemErrorTitle, message: SystemErrorMsg } });
        return true
    } else {
        return false
    }
};
